"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeConsumer = exports.ThemeProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _defaultTheme = _interopRequireDefault(require("./default-theme"));

/**
 * Use React 16.3+ createContext API.
 */
var _React$createContext = _react.default.createContext(_defaultTheme.default),
    ThemeProvider = _React$createContext.Provider,
    ThemeConsumer = _React$createContext.Consumer;

exports.ThemeConsumer = ThemeConsumer;
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90aGVtZS9zcmMvVGhlbWVDb250ZXh0LmpzIl0sIm5hbWVzIjpbIlJlYWN0IiwiY3JlYXRlQ29udGV4dCIsImRlZmF1bHRUaGVtZSIsIlRoZW1lUHJvdmlkZXIiLCJQcm92aWRlciIsIlRoZW1lQ29uc3VtZXIiLCJDb25zdW1lciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBRUE7OzsyQkFNSUEsZUFBTUMsYUFBTixDQUFvQkMscUJBQXBCLEM7SUFGUUMsYSx3QkFBVkMsUTtJQUNVQyxhLHdCQUFWQyxRIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IGRlZmF1bHRUaGVtZSBmcm9tICcuL2RlZmF1bHQtdGhlbWUnXG5cbi8qKlxuICogVXNlIFJlYWN0IDE2LjMrIGNyZWF0ZUNvbnRleHQgQVBJLlxuICovXG5jb25zdCB7XG4gIFByb3ZpZGVyOiBUaGVtZVByb3ZpZGVyLFxuICBDb25zdW1lcjogVGhlbWVDb25zdW1lclxufSA9IFJlYWN0LmNyZWF0ZUNvbnRleHQoZGVmYXVsdFRoZW1lKVxuXG5leHBvcnQgeyBUaGVtZVByb3ZpZGVyLCBUaGVtZUNvbnN1bWVyIH1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/theme/src/ThemeContext.js
// module id = 96
// module chunks = 0